// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DqZgBsvdDxZXiRak6K33 {
	position: relative;
}

.DqZgBsvdDxZXiRak6K33.uKfII_Dkm3PWtJsvzCi4 {
		pointer-events: none;
	}

.DqZgBsvdDxZXiRak6K33.uKfII_Dkm3PWtJsvzCi4 > .VLUPcFVdT9Qe3yB7P5B1 {
			padding-right: 12px;
		}

.VLUPcFVdT9Qe3yB7P5B1 {
	display: flex;
	justify-content: space-between;
	align-items: center;
	gap: 8px;
	width: 100%;
	height: 40px;
	padding: 0 8px 0 12px;
	border-radius: 8px;
	cursor: pointer;
	background-color: var(--black);
}

.jKmlcTGCxcGggQevM6HH {
	position: absolute;
	z-index: 2;
	top: 100%;
	left: 0;
	min-width: 100%;
	padding: 8px 12px;
	border-radius: 8px;
	background-color: var(--black);
}

.bmGQHlbKquWZXrL2khvZ {
	font-weight: 400;
	display: flex;
	align-items: center;
	min-height: 40px;
	line-height: 16px;
	cursor: pointer;
}

.yWYJRS9EuQekbf3hC89d {
	cursor: default;
	opacity: 0.5;
}
`, "",{"version":3,"sources":["webpack://./src/components/Select/Select.pcss"],"names":[],"mappings":"AAAA;CACC,kBAAkB;AASnB;;AAPC;EACC,oBAAoB;CAKrB;;AAHC;GACC,mBAAmB;EACpB;;AAIF;CACC,aAAa;CACb,8BAA8B;CAC9B,mBAAmB;CACnB,QAAQ;CACR,WAAW;CACX,YAAY;CACZ,qBAAqB;CACrB,kBAAkB;CAClB,eAAe;CACf,8BAA8B;AAC/B;;AAEA;CACC,kBAAkB;CAClB,UAAU;CACV,SAAS;CACT,OAAO;CACP,eAAe;CACf,iBAAiB;CACjB,kBAAkB;CAClB,8BAA8B;AAC/B;;AAEA;CACC,gBAAgB;CAChB,aAAa;CACb,mBAAmB;CACnB,gBAAgB;CAChB,iBAAiB;CACjB,eAAe;AAChB;;AAEA;CACC,eAAe;CACf,YAAY;AACb","sourcesContent":[".root {\n\tposition: relative;\n\n\t&.disabled {\n\t\tpointer-events: none;\n\n\t\t& > .select {\n\t\t\tpadding-right: 12px;\n\t\t}\n\t}\n}\n\n.select {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: center;\n\tgap: 8px;\n\twidth: 100%;\n\theight: 40px;\n\tpadding: 0 8px 0 12px;\n\tborder-radius: 8px;\n\tcursor: pointer;\n\tbackground-color: var(--black);\n}\n\n.options {\n\tposition: absolute;\n\tz-index: 2;\n\ttop: 100%;\n\tleft: 0;\n\tmin-width: 100%;\n\tpadding: 8px 12px;\n\tborder-radius: 8px;\n\tbackground-color: var(--black);\n}\n\n.optionItem {\n\tfont-weight: 400;\n\tdisplay: flex;\n\talign-items: center;\n\tmin-height: 40px;\n\tline-height: 16px;\n\tcursor: pointer;\n}\n\n.optionItemDisabled {\n\tcursor: default;\n\topacity: 0.5;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `DqZgBsvdDxZXiRak6K33`,
	"disabled": `uKfII_Dkm3PWtJsvzCi4`,
	"select": `VLUPcFVdT9Qe3yB7P5B1`,
	"options": `jKmlcTGCxcGggQevM6HH`,
	"optionItem": `bmGQHlbKquWZXrL2khvZ`,
	"optionItemDisabled": `yWYJRS9EuQekbf3hC89d`
};
export default ___CSS_LOADER_EXPORT___;
